export default {
  setMyFlyers: (state, list) => {
    state.myFlyers = list;
  }
};
